import FormattedMessage from 'I18n/components/FormattedMessage';
import { ArchiveIcon } from 'foundations-assets';
import { Link } from 'foundations-components/transitional/components/Link';
import { memo } from 'react';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
function BulkUnarchiveButton({
  hasBulkWriteAccess,
  onClick
}) {
  if (!hasBulkWriteAccess) {
    return null;
  }
  return /*#__PURE__*/_jsxs(Link, {
    "data-test-id": "unarchive-link",
    onClick: onClick,
    children: [/*#__PURE__*/_jsx(ArchiveIcon, {}), /*#__PURE__*/_jsx(FormattedMessage, {
      message: "email-management.table.bulkActions.unarchive"
    })]
  });
}
export default /*#__PURE__*/memo(BulkUnarchiveButton);